<template>
    <transition name="modal">  
        <!-- The Modal -->
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-dialog modal-dialog-scrollable">
                    <div class="modal-content rounded-8">

                        <!-- Modal Header -->
                        <div class="modal-header bg-utel-v2-secondary text-primary">
                            <h5 class="modal-title"><strong>Editar información</strong></h5>
                            <button type="button" @click="close" class="close" data-dismiss="modal">×</button>
                        </div>
                        
                        <!-- Modal body -->
                        <div class="modal-body">
                            <div class="row col-12">
                                <small>Cambia los campos... y guarda.</small>
                            </div>
                            <div class="row col-12 pb-0">
                                <div class="form-group">
                                    <small>Nombre del administrador</small>
                                    <input type="text" class="rounded-8 form-control sin-borde text-primary" v-model="admin.firstname" placeholder="Nombre del usuario">
                                </div>
                            </div>
                            <div class="row col-12 py-0">
                                <div class="form-group">
                                    <small>Apellido del administrador</small>
                                    <input type="text" class="rounded-8 form-control sin-borde text-primary" v-model="admin.lastname" placeholder="Apellido del usuario">
                                </div>
                            </div>
                            <div class="row col-12 py-0">
                                <div class="form-group">
                                    <small>Rol del administrador</small>
                                    <select v-model="admin.role" class="rounded-8 form-control sin-borde text-primary">
                                        <option v-for="r of getRolesAdmin(roles)" :key="r.id" :value="r.name"> {{ r.name }} </option>
                                    </select>
                                </div>
                            </div>
                            <div class="row col-12 pt-0">
                                <div class="form-group">
                                    <small>Firma del administrador. (300x300 px en JPG, JPEG, PNG)</small>
                                    <input type="file" v-on:change="attachSign" ref="signPhoto"
                                        class="form-control rounded-8 sin-borde" placeholder="Logo" aria-label="Logo"
                                        id="admin-firma" accept="image/*" required />                            
                                </div>
                            </div>
                        </div>
                        
                        <!-- Modal footer -->
                        <div class="modal-footer">
                            <button type="button" class="btn text-primary bg-utel-v2-secondary rounded-8 sin-borde mx-3" @click="close" aria-label="Close modal" :disabled="btnGuardar.disabled">Cancelar</button>
                            <button type="button" class="btn text-white rounded-8 bg-utel" @click="editarUsuario" aria-label="Eliminar usuario" v-text="btnGuardar.text" :disabled="btnGuardar.disabled"></button>                           
                        </div>                        
                    </div>
                </div>
            </div>
        </div>        
    </transition>
</template>

<script>
export default {
    props: ["student", "url", "roles"],
    data(){
        return{
            admin: {
                firstname: '',
                lastname: '',
                role: '',
                file: ''
            },
            urlEditUser : this.url+"/"+this.student.id,
            error: [],
            btnGuardar:{
                text : "Guardar cambios",
                disabled: false
            }
        }
    },
    mounted(){        
        this.admin.firstname = this.student.firstname;
        this.admin.lastname = this.student.lastname;
        this.admin.role = this.student.role;
        this.admin.role_id = this.student.role_id;
    },
    methods: {
        close() {            
            this.$emit('close');
        },
        editarUsuario(){
            let context = this;
            context.btnGuardar.text = "Procesando ...";
            context.btnGuardar.disabled = true;

            const config = { headers: { 'content-type': 'multipart/form-data' } }
            let dataAdmin = new FormData();
            for (const [key, value] of Object.entries(this.admin)) {
                dataAdmin.append(key, value);
            }
            dataAdmin.append("_method", "put");

            axios
            .post(context.urlEditUser, dataAdmin, config)
            .then((res) => {
                context.$emit('reloadtable', true);
                context.close();
                //this.$emit('iratabla', 'tabla');
            })
            .catch((err) => {
                context.error = err.response.data.errors;
            })
            .finally(()=>{
                context.btnGuardar.text = "Guardar cambios";
                context.btnGuardar.disabled = false;
            });
        },
        getRolesAdmin(rol){
            return rol.filter((element)=>{
                return element.name == 'SU' || element.name == 'admin';
            });
        },
        attachSign() {
            this.admin.file = this.$refs.signPhoto.files[0];
        },
    },
};
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  /*display: table;*/
  transition: opacity .3s ease;
}

.modal-wrapper {
  /*display: table-cell;*/
  vertical-align: middle;
}
</style>